import React from "react";
import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/system";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
const Btn = styled(Button)`
  position: absolute;
  top: 170px;
  background-color: white;
  color: black;
  box-shadow: none;
  letter-spacing: 0.3em;
  display: none;
  &:hover {
    background-color: #a9a9a9;
  }
  &:focus {
    background-color: green;
  }
`;
const Container = styled(Box)`
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
  position: relative;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  &:hover {
    btn: {
    }
  }
`;

const useStyles = makeStyles({
  imgWrap: {
    overflow: "hidden",
    display: "inline-block",
    width: "280px",
    height: "290px",
    "&:hover": { backgroundColor: "black" },
    "&:hover $btn": { display: "block" },
  },
  btn: {
    position: "relative",
    top: "-180px",
    left: "+87px",
    backgroundColor: "#212a2f",
    color: "white",
    letterSpacing: "3px",
    textTransform: "uppercase",
    padding: "20px",
    border: "none",
    display: "none",
    cursor: "pointer",
  },
  img: {
    width: "100%",
    height: "100%",
    transition: "all .1s ease-in-out",
    display: "inline-block",
    "&:hover": {
      transform: "scale(1.2)",
    },
  },
  bottom: {
    paddingTop: "10px",
    paddingBottom: "10px",
    borderBottom: "1px solid lightgray",
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
  },
  text: {
    padding: "20px",
    textAlign: "center",
    fontSize: "13px",
    fontWeight: "lighter",
  },
});

const IndexMiddleOutdoor = () => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  return (
    <Box sx={{ pt: 4, display: "flex", justifyContent: "space-around" }}>
      <Container>
        <HashLink to="/product/all-purpose-wipe#top">
          <Box className={classes.imgWrap}>
            <img
              className={classes.img}
              style={{
                backgroundSize: "cover",
                transition: "all .2s ease-in-out",
              }}
              alt=""
              src="https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80"
            />
            <button className={classes.btn}>{t("learn_more")}</button>
          </Box>
          <Btn variant="contained">Click</Btn>
          <Box className={classes.bottom} sx={{ pt: 2 }}>
            {t("index_middle_home1")}
          </Box>
          <Box className={classes.text}>{t("index_middle_home1_exp")}</Box>
        </HashLink>
      </Container>

      <Container>
        <HashLink to="/product/all-purpose-spray#top">
          <Box className={classes.imgWrap}>
            <img
              className={classes.img}
              style={{
                backgroundSize: "cover",
                transition: "all .2s ease-in-out",
              }}
              width="340"
              height="330"
              alt=""
              src="https://images.unsplash.com/photo-1600607686527-6fb886090705?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80"
            />
            <button className={classes.btn}>{t("learn_more")}</button>
          </Box>

          <Box className={classes.bottom}>{t("index_middle_home2")}</Box>
          <Box className={classes.text}>{t("index_middle_home2_exp")}</Box>
        </HashLink>
      </Container>

      <Container>
        <HashLink to="/product/pet-spray#top">
          <Box className={classes.imgWrap}>
            <img
              className={classes.img}
              style={{
                // backgroundSize: "cover",
                transition: "all .2s ease-in-out",
              }}
              width="340"
              height="330"
              alt=""
              src="/img/rayon-index.jpeg"
            />
            {/* <button className={classes.btn}>{t("learn_more")}</button> */}
          </Box>

          <Box className={classes.bottom}>{t("index_middle_home3")}</Box>
          <Box className={classes.text}>{t("index_middle_home3_exp")}</Box>
        </HashLink>
      </Container>
    </Box>
  );
};

export default IndexMiddleOutdoor;
